{
  "links" : {
    "triggerLinksDescription" : "Ligações de acionadores Ativar utilizador para colocar links Interior de mensagens SMS e Gmail, que Ativar utilizador para rastrear atividades específicas do cliente e acionador ocorrências com base no Ativado Quando o Ligar, vincular é clicado.",
    "enterName" : "Introduzir nome",
    "enterLinkURL" : "Introduza o URL da ligação",
    "save" : "Arquivo",
    "cancel" : "Cancelar",
    "delete" : "Eliminar",
    "aboutToDeleteLink" : "'Utilizador're Acerca de para eliminar o ${deleteRowName} acionador Ligar, vincular. Eliminado Ligar, o vincular não pode ser restaurado, tem a certeza de que o utilizador pretende Continuar?",
    "noTriggerLinksFound" : "Nenhuma ligação de acionadores encontrada",
    "getStartedByAddingNewTriggerLinks" : "Começar a adicionar novas Ligações de acionadores",
    "newTriggerLink" : "Novo acionador Ligar, vincular",
    "searchNoMatch" : "A sua Pesquisa não encontrou nenhum acionador Ligar, vincular.",
    "link" : "Ligar, vincular",
    "addLink" : "Adicionar Ligar, vincular",
    "linkURL" : "URL da ligação",
    "name" : "Nome",
    "pleaseEnterNonEmptyLinkName" : "Insira um Ligar não vazio, nome vincular",
    "pleaseEnterURL" : "Introduza o URL",
    "actions" : "atividades",
    "linkKey" : "Chave de Ligar, vincular",
    "keyCopied" : "Chave copiado"
  }
}
